<script>
    import ColorRange from '@/components/page-setting/ColorRange.vue';
    import DisplayColor from '@/components/page-setting/DisplayColor.vue';
    import ColorPicker from '@/components/page-setting/ColorPicker.vue';

    export default {
        components: {
            ColorRange: ColorRange,
            DisplayColor: DisplayColor,
            ColorPicker: ColorPicker
        },
        computed: {
            customColor() {return this.$store.getters.CUSTOM_COLOR}
        },
        methods: {
            async updateColor(event, color) {
                const newValue = Number(event.target.value);
                await this.$store.dispatch('CHANGE_CUSTOM_COLOR', {
                    value: newValue,
                    color: color 
                });
            }
        }
    }
</script>


<template>
    <div class="picker_container">
        <div class="input_container">
            <ColorRange 
                name="red" 
                :value="customColor.MAIN.red" 
                :changeValue="updateColor"
            />
            <ColorRange 
                name="green" 
                :value="customColor.MAIN.green" 
                :changeValue="updateColor"
            />
            <ColorRange 
                name="blue" 
                :value="customColor.MAIN.blue" 
                :changeValue="updateColor"
            />
            <ColorPicker />
        </div>
        <div class="display_container">
            <DisplayColor
                :color="`rgb(
                    ${customColor.MAIN_4UP.red},
                    ${customColor.MAIN_4UP.green},
                    ${customColor.MAIN_4UP.blue}
                )`"
            />
            <DisplayColor
                :color="`rgb(
                    ${customColor.MAIN_2UP.red},
                    ${customColor.MAIN_2UP.green},
                    ${customColor.MAIN_2UP.blue}
                )`"
            />
            <DisplayColor 
                :color="`rgb(
                    ${customColor.MAIN.red},
                    ${customColor.MAIN.green},
                    ${customColor.MAIN.blue}
                )`"
            />
            <DisplayColor 
                :color="`rgb(
                    ${customColor.MAIN_2DOWN.red},
                    ${customColor.MAIN_2DOWN.green},
                    ${customColor.MAIN_2DOWN.blue}
                )`"
            />
            <DisplayColor
                :color="`rgb(
                    ${customColor.MAIN_4DOWN.red},
                    ${customColor.MAIN_4DOWN.green},
                    ${customColor.MAIN_4DOWN.blue}
                )`"
            />
        </div>
    </div>
</template>


<style scoped>
    .picker_container {
        display: flex;
        flex-direction: row;
        padding: 5px;
    }
    .input_container {
        flex: 0 0 300px;
        display: flex;
        flex-direction: column;
        margin-right: 50px;
    }
    .display_container {
        flex: 1 1 100%;
        display: flex;
        flex-direction: row;
    }
</style>